/* App bookings arrive with the literal "App" in bookedby, where a module
   booking carries the employee's name. Trimmed + lowercased because the value
   is backend text, not an enum. */
export const isAppBooking = (record: any): boolean =>
    String(record?.bookedby ?? "").trim().toLowerCase() === "app";

export const isFlagOn = (value: unknown): boolean =>
    value === true ||
    value === 1 ||
    value === "true" ||
    value === "1";
